import React, { useEffect } from "react";
import Header from "./Header";
import Home from "./Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Checkout from "./Checkout";
import Login from "./Login";
import Orders from './Orders'
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import Payment from "./Payment";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const promise = loadStripe (
  "pk_test_51HQezoGQkzeUTptR4L69zeKUiwsniXldZmAocMT6raf6DRg0unAOaCVWcQBKgCeux1AptLpsq7R2bU81fZc7dLj000tWALqBAL"
)

function App() {
  const [{}, dispatch] = useStateValue() 

  useEffect(() => {
    // will only run once when the app component loads

    // firebase listener, keep listening
    auth.onAuthStateChanged(authUser => {
      console.log("The USER is >> ", authUser)

      if (authUser) {
        // the user just logged in / the user was logged in
        dispatch({
          type: "SET_USER",
          user: authUser,
        })
      } else {
        // the user is logged out
        dispatch({
          type: "SET_USER",
          user: null,
        })
      }
    })

  }, [])


  return (
    <Router>
      <div className="app">    
        <Switch>
        
          <Route path="/orders">
            <Header />
            <Orders />
          </Route>

          <Route path="/login">
            <Login />
          </Route>

          <Route path="/checkout">
            <Header />  
            <Checkout />
          </Route>

          <Route path="/payment">
            <Header />

            {/* HIgher order function */}
            <Elements stripe={promise}>
              <Payment /> 
            </Elements>
            
          </Route>

          {/* Your default route will be at the bottom; otherwise it will not work */}
          <Route path="/">
            <Header />
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
